/* NOCPIX OMNI: Bühne, Modellwahl, Clip-Schiene, Film-Dialog, Bildmodi, Kaufbalken.
   Ohne dieses Skript bleibt jeder Inhalt sichtbar (Progressive Enhancement). */
(function(){
  if (window.__omniGeladen) return; window.__omniGeladen = true;
  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('js-omni');

  function jeder(sel, wurzel, fn){ Array.prototype.forEach.call((wurzel||document).querySelectorAll(sel), fn); }

  /* Einblenden beim Scrollen */
  var ein = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('ist-da'); ein.unobserve(e.target); } });
  }, {rootMargin:'0px 0px -8% 0px', threshold:.12}) : null;
  jeder('[data-o-ein]', null, function(el){ ein ? ein.observe(el) : el.classList.add('ist-da'); });

  /* Bühne: Film erst laden, wenn sichtbar; passende Größe je Bildschirm */
  jeder('[data-omni-buehne]', null, function(b){
    requestAnimationFrame(function(){ b.classList.add('ist-da'); });
    var v = b.querySelector('[data-omni-loop]'), knopf = b.querySelector('[data-omni-pause]');
    if (!v) return;
    if (ruhig){ if (knopf) knopf.hidden = true; return; }
    var gross = window.matchMedia('(min-width: 1000px)').matches;
    var geladen = false, angehalten = false;
    function laden(){
      if (geladen) return; geladen = true;
      v.src = gross ? v.dataset.gross : v.dataset.klein;
      v.addEventListener('playing', function(){ v.classList.add('ist-bereit'); }, {once:true});
      var p = v.play(); if (p && p.catch) p.catch(function(){});
    }
    var sicht = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (e.isIntersecting){ laden(); if (!angehalten){ var p = v.play(); if (p && p.catch) p.catch(function(){}); } }
        else if (geladen){ v.pause(); }
      });
    }, {threshold:.15});
    sicht.observe(b);
    if (knopf) knopf.addEventListener('click', function(){
      angehalten = !angehalten;
      knopf.setAttribute('aria-pressed', angehalten);
      knopf.setAttribute('aria-label', angehalten ? 'Hintergrundfilm abspielen' : 'Hintergrundfilm anhalten');
      if (angehalten) v.pause(); else { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
    });
  });

  /* Modellwahl: Schalter, Preis, Fakten und Warenkorb-Variante tauschen */
  jeder('[data-omni-wahl]', null, function(w){
    var schalter = w.querySelector('.o-schalter');
    var knoepfe = w.querySelectorAll('[data-omni-modell]');
    var tafeln = w.querySelectorAll('[data-omni-tafel]');
    var feld = w.querySelector('[data-omni-variante]');
    var mehr = w.querySelector('[data-omni-mehr]');
    Array.prototype.forEach.call(knoepfe, function(k, i){
      k.addEventListener('click', function(){
        schalter.setAttribute('data-aktiv', i);
        Array.prototype.forEach.call(knoepfe, function(x){ x.setAttribute('aria-pressed', x === k); });
        Array.prototype.forEach.call(tafeln, function(t, j){ t.classList.toggle('ist-aktiv', j === i); t.setAttribute('aria-hidden', j !== i); });
        if (feld) feld.value = k.dataset.variante;
        if (mehr){ mehr.href = k.dataset.url; mehr.querySelector('span').textContent = k.dataset.name; }
      });
    });
  });

  /* Clip-Schienen: Pfeile, Ziehen mit Maus, Clips spielen nur im Bild */
  jeder('[data-omni-schiene]', null, function(box){
    var s = box.querySelector('.oc__schiene');
    var zurueck = box.querySelector('[data-richtung="-1"]'), vor = box.querySelector('[data-richtung="1"]');
    function schritt(){ var k = s.querySelector('.oc__karte'); return k ? k.getBoundingClientRect().width + 18 : 300; }
    function pfeile(){
      if (!zurueck) return;
      zurueck.disabled = s.scrollLeft < 8;
      vor.disabled = s.scrollLeft + s.clientWidth >= s.scrollWidth - 8;
    }
    [zurueck, vor].forEach(function(b){ if (b) b.addEventListener('click', function(){
      s.scrollBy({left: schritt() * +b.dataset.richtung, behavior: ruhig ? 'auto' : 'smooth'});
    }); });
    s.addEventListener('scroll', pfeile, {passive:true}); pfeile();

    /* Ziehen mit der Maus (Touch scrollt nativ) */
    var start = null, links = 0, bewegt = false;
    s.addEventListener('pointerdown', function(e){ if (e.pointerType !== 'mouse') return; start = e.clientX; links = s.scrollLeft; bewegt = false; });
    window.addEventListener('pointermove', function(e){
      if (start === null) return;
      var d = e.clientX - start;
      if (!bewegt && Math.abs(d) > 6){ bewegt = true; s.classList.add('zieht'); }
      if (bewegt) s.scrollLeft = links - d;
    });
    window.addEventListener('pointerup', function(){
      if (start === null) return; start = null;
      if (bewegt){ s.classList.remove('zieht'); var w = schritt(); s.scrollTo({left: Math.round(s.scrollLeft / w) * w, behavior: ruhig ? 'auto' : 'smooth'}); }
    });

    if (ruhig) return;
    var clipSicht = new IntersectionObserver(function(es){
      es.forEach(function(e){
        var v = e.target;
        if (e.intersectionRatio > .6){
          if (!v.src) v.src = v.dataset.src;
          var p = v.play(); if (p && p.then) p.then(function(){ v.classList.add('laeuft'); }).catch(function(){});
        } else if (v.src){ v.pause(); }
      });
    }, {threshold:[0,.6,1]});
    jeder('video[data-src]', box, function(v){ clipSicht.observe(v); });
  });

  /* Film-Dialog */
  jeder('[data-omni-film-auf]', null, function(k){
    var d = document.getElementById(k.getAttribute('aria-controls'));
    if (!d || typeof d.showModal !== 'function') return;
    var v = d.querySelector('video');
    k.addEventListener('click', function(e){
      e.preventDefault();
      if (!v.src) v.src = v.dataset.src;
      d.showModal(); var p = v.play(); if (p && p.catch) p.catch(function(){});
    });
    d.addEventListener('close', function(){ v.pause(); });
    d.addEventListener('click', function(e){ if (e.target === d) d.close(); });
    d.querySelector('[data-omni-film-zu]').addEventListener('click', function(){ d.close(); });
  });

  /* Film-Band auf der Produktseite: an Ort und Stelle abspielen */
  jeder('[data-omni-film-inline]', null, function(k){
    k.addEventListener('click', function(){
      var v = document.createElement('video');
      v.src = k.dataset.src; v.controls = true; v.autoplay = true; v.playsInline = true;
      v.setAttribute('poster', k.dataset.poster || '');
      k.parentNode.appendChild(v); k.hidden = true; k.parentNode.querySelector('.op-film__text').hidden = true; var vs = k.parentNode.querySelector('[data-omni-vorschau]'); if (vs){ vs.pause(); vs.hidden = true; }
      var p = v.play(); if (p && p.catch) p.catch(function(){});
      v.focus();
    });
  });

  /* Drei Bildmodi: Reiter tauschen Bild und Text (Pfeiltasten wie bei Tabs üblich) */
  jeder('[data-omni-modi]', null, function(m){
    var reiter = m.querySelectorAll('[role="tab"]'), texte = m.querySelectorAll('[role="tabpanel"]'), bilder = m.querySelectorAll('[data-omni-modus-bild]'), stempel = m.querySelector('.op-modi__stempel');
    function wahl(i, fokus){
      Array.prototype.forEach.call(reiter, function(r, j){ r.setAttribute('aria-selected', j === i); r.tabIndex = j === i ? 0 : -1; });
      Array.prototype.forEach.call(texte, function(t, j){ t.classList.toggle('ist-aktiv', j === i); t.setAttribute('aria-hidden', j !== i); });
      Array.prototype.forEach.call(bilder, function(t, j){ t.classList.toggle('ist-aktiv', j === i); });
      if (stempel) stempel.textContent = reiter[i].textContent;
      if (fokus) reiter[i].focus();
    }
    Array.prototype.forEach.call(reiter, function(r, i){
      r.addEventListener('click', function(){ wahl(i); });
      r.addEventListener('keydown', function(e){
        if (e.key === 'ArrowRight'){ e.preventDefault(); wahl((i + 1) % reiter.length, true); }
        if (e.key === 'ArrowLeft'){ e.preventDefault(); wahl((i - 1 + reiter.length) % reiter.length, true); }
      });
    });
  });

  /* 4K gegen 8K: der Regler liegt unsichtbar über dem Bild und ist per Tastatur bedienbar */
  jeder('[data-omni-vgl]', null, function(v){
    var r = v.querySelector('input');
    function setzen(){ v.style.setProperty('--pos', r.value + '%'); }
    r.addEventListener('input', setzen); setzen();
    if (ruhig) return;
    /* Einmaliger Hinweis beim ersten Sichtkontakt: Regler wandert kurz an und zurück */
    var gesehen = false;
    new IntersectionObserver(function(es){
      if (gesehen || !es[0].isIntersecting) return; gesehen = true;
      var t0 = null;
      function lauf(t){
        if (t0 === null) t0 = t;
        var x = Math.min((t - t0) / 1400, 1);
        r.value = 50 + Math.sin(x * Math.PI * 2) * 18 * (1 - x); setzen();
        if (x < 1 && !v.matches(':active')) requestAnimationFrame(lauf); else { r.value = 50; setzen(); }
      }
      setTimeout(function(){ requestAnimationFrame(lauf); }, 400);
    }, {threshold:.6}).observe(v);
  });

  /* Funktions-Kino: große Bühne, Kapitel laufen nacheinander, Fortschritt im Balken.
     Mindestdauer je Kapitel 5 s (kurze Clips laufen in Schleife), Pause außerhalb des Bilds. */
  jeder('[data-omni-kino]', null, function(k){
    var filme = k.querySelectorAll('.ok__film'), kap = k.querySelectorAll('.ok__kapitel');
    var text = k.querySelector('[data-omni-kino-text]'), titel = k.querySelector('[data-omni-kino-titel]'), nr = k.querySelector('[data-omni-kino-nr]'), zahl = k.querySelector('[data-omni-kino-zahl]');
    var poster = k.querySelector('.ok__poster');
    var aktiv = -1, vorn = 0, start = 0, laeuft = false, sichtbar = false, raf = 0, dauer = 5000, stand = 0;
    function balken(i, x){ var b = kap[i] && kap[i].querySelector('.ok__balken i'); if (b) b.style.transform = 'scaleX(' + x + ')'; }
    function zeige(i, vonHand){
      if (i === aktiv && !vonHand) return;
      if (aktiv >= 0) balken(aktiv, 0);
      aktiv = i;
      Array.prototype.forEach.call(kap, function(x, j){ x.classList.toggle('ist-aktiv', j === i); x.setAttribute('aria-pressed', j === i); });
      var t = kap[i].querySelector('b').textContent, be = kap[i].querySelector('.ok__k-text span').textContent, n = (i < 9 ? '0' : '') + (i + 1);
      titel.classList.add('wechselt'); text.classList.add('wechselt');
      setTimeout(function(){ titel.textContent = t; text.textContent = be; nr.textContent = n; zahl.textContent = n; titel.classList.remove('wechselt'); text.classList.remove('wechselt'); }, 220);
      if (ruhig && !vonHand){ poster.src = kap[i].dataset.poster; return; }
      var neu = filme[1 - vorn], alt = filme[vorn];
      neu.loop = true; neu.src = kap[i].dataset.src; neu.currentTime = 0;
      var p = neu.play(); if (p && p.catch) p.catch(function(){});
      neu.addEventListener('playing', function(){
        neu.classList.add('ist-vorn'); alt.classList.remove('ist-vorn');
        setTimeout(function(){ if (!alt.classList.contains('ist-vorn')) alt.pause(); }, 600);
        dauer = Math.max(5000, (neu.duration || 5) * 1000 * (neu.duration < 3 ? 3 : 1));
        start = performance.now();
      }, {once:true});
      vorn = 1 - vorn;
      start = performance.now(); stand = 0;
      if (vonHand && ruhig) neu.loop = false;
    }
    function takt(t){
      raf = requestAnimationFrame(takt);
      if (!laeuft || aktiv < 0) return;
      var x = Math.min((t - start) / dauer, 1); stand = x;
      balken(aktiv, x);
      if (x >= 1) zeige((aktiv + 1) % kap.length);
    }
    Array.prototype.forEach.call(kap, function(b, i){
      b.addEventListener('click', function(){
        zeige(i, true);
        if (window.matchMedia('(max-width: 999px)').matches) k.querySelector('.ok__buehne').scrollIntoView({behavior: ruhig ? 'auto' : 'smooth', block:'nearest'});
      });
    });
    if (ruhig) return;
    new IntersectionObserver(function(es){
      sichtbar = es[0].isIntersecting;
      if (sichtbar){
        if (aktiv < 0) zeige(0, true);
        else { var v = filme[1 - vorn]; var p = v.play(); if (p && p.catch) p.catch(function(){}); start = performance.now() - dauer * stand; }
        laeuft = true; if (!raf) raf = requestAnimationFrame(takt);
      } else {
        laeuft = false; Array.prototype.forEach.call(filme, function(v){ v.pause(); });
      }
    }, {threshold:.45}).observe(k.querySelector('.ok__buehne'));
  });

  /* Film-Band: laufende Vorschau, sobald sichtbar */
  jeder('[data-omni-vorschau]', null, function(v){
    if (ruhig) return;
    var gross = window.matchMedia('(min-width: 1000px)').matches, geladen = false;
    v.addEventListener('playing', function(){ v.classList.add('ist-bereit'); }, {once:true});
    new IntersectionObserver(function(es){
      if (es[0].isIntersecting){ if (!geladen){ geladen = true; v.src = gross ? v.dataset.gross : v.dataset.klein; } var p = v.play(); if (p && p.catch) p.catch(function(){}); }
      else if (geladen) v.pause();
    }, {threshold:.2}).observe(v);
  });

  /* Kaufbalken: erscheint, sobald der Kaufknopf der Produktseite aus dem Bild ist */
  jeder('[data-omni-balken]', null, function(bar){
    var ziel = document.querySelector('.product-detail .add-to-cart') || document.querySelector('.product-detail');
    var fuss = document.querySelector('footer, .site-footer');
    if (!ziel) return;
    var oben = false, unten = false;
    function zeigen(){ bar.classList.toggle('ist-sichtbar', oben && !unten); bar.setAttribute('aria-hidden', !(oben && !unten)); }
    new IntersectionObserver(function(es){ oben = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; zeigen(); }).observe(ziel);
    if (fuss) new IntersectionObserver(function(es){ unten = es[0].isIntersecting; zeigen(); }).observe(fuss);
  });
})();
